export const npsHelper = {
  npsColor,
  npsValue
}

function npsValue(valor) {
  if (valor >= 0 && valor <= 6) return 33.33;
  else if (valor >= 7 && valor <= 8) return 66.66;
  else if (valor >= 9 && valor <= 10) return 100;
}

function npsColor(valor) {
  if (valor >= 0 && valor <= 6) return 'error';
  else if (valor >= 7 && valor <= 8) return 'yellow darken-1';
  else if (valor >= 9 && valor <= 10) return 'success darken-1';
}